import { Card, Slider, Button, Select } from "antd";
import { get } from "lodash";
import moment from "moment-timezone";
import { useEffect, useState, Fragment, useMemo } from "react";
import { SHIFT_PREFERENCE } from "src/constants/agents";
import { getWorkerQualifications, workerPreferences } from "@src/appV2/redesign/utils/worker";
import { Colors } from "src/utils/colors";
import { saveAgentPreference } from "src/containers/agentDrawer/api";
import "./style.css";
import { useGetOpenShiftDates } from "src/containers/agentDashboard/useGetOpenShiftDates";

const { Option } = Select;

function ShiftSearchPreference({
  minDistanceSlider = 1,
  maxDistanceSlider = 150,
  step = 1,
  agent,
  admin,
}) {
  const [upcomingShifts, setUpcomingShifts] = useState(0);
  const [distance, setDistance] = useState(
    get(agent, "preference.distance", SHIFT_PREFERENCE.DISTANCE)
  );
  const [sliderDistance, setSliderDistance] = useState(
    get(agent, "preference.distance", SHIFT_PREFERENCE.DISTANCE)
  );
  const [qualification, setQualification] = useState("");

  useEffect(() => {
    setQualification(get(agent, "preference.qualification", "CNA"));
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agent?.qualification, agent?.preference?.qualification]);

  const agentQualifications = useMemo(() => {
    return getWorkerQualifications(agent?.licensesData);
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agent?.licensesData, agent?.preference.qualification]);

  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const tipFormatterDistance = (distance) => `${distance} ${distance > 1 ? "miles" : "mile"}`;

  const updatePreference = async (preference, value) => {
    const preferredValue = ["string", "number"].includes(typeof value) ? value : value[0];

    await saveAgentPreference({
      key: preference,
      value: preferredValue,
      agentId: agent.userId,
      performedBy: admin,
    });
    if (preference === workerPreferences.DISTANCE) {
      setSliderDistance(preferredValue);
      setDistance(preferredValue);
    } else if (preference === workerPreferences.QUALIFICATION) {
      setQualification(preferredValue);
    }
  };

  const { data: openShiftDates, isLoading: isLoadingOpenShifts } = useGetOpenShiftDates(
    agent?.userId,
    {
      dateFilter: {
        start: moment().format("YYYY-MM-DD"),
        end: moment().add(2, "week").format("YYYY-MM-DD"),
      },
      distance,
      qualification,
      coordinates: agent?.geoLocation?.coordinates,
      tmz: agent?.tmz,
      specialities: agent?.specialities,
    }
  );

  useEffect(() => {
    if (openShiftDates) {
      const totalShifts = openShiftDates.data.reduce(
        (acc, shift) => acc + shift.attributes.total,
        0
      );
      setUpcomingShifts(totalShifts);
    }
  }, [openShiftDates]);

  const resetPreferences = () => {
    void updatePreference(workerPreferences.DISTANCE, [SHIFT_PREFERENCE.DISTANCE]);
  };

  function ResetButton() {
    return (
      <Fragment>
        <Button
          type="link"
          onClick={resetPreferences}
          disabled={distance === SHIFT_PREFERENCE.DISTANCE}
        >
          Reset Defaults
        </Button>
      </Fragment>
    );
  }

  return (
    <Card title="Shift Search Preference" extra={<ResetButton />}>
      <div>
        <div data-testid="distance-preference">
          <span
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingTop: "0.5rem",
            }}
          >
            <span>Maximum Distance (home to workplace)</span>
            <span style={{ color: Colors.primary }}>{distance} Miles</span>
          </span>
          <Slider
            min={minDistanceSlider}
            max={maxDistanceSlider}
            step={step}
            defaultValue={sliderDistance}
            onAfterChange={(value) => updatePreference(workerPreferences.DISTANCE, value)}
            onChange={(value) => setSliderDistance(value[0])}
            tipFormatter={tipFormatterDistance}
            disabled={isLoadingOpenShifts}
            marks={{
              1: "1",
              25: "25",
              50: "50",
              75: "75",
              100: "100",
              125: "125",
              150: "150",
            }}
          />
        </div>
      </div>
      <p data-testid="qualification-filter-shift-count" style={{ marginTop: "50px" }}>
        <Select
          style={{ width: 300, marginRight: "20px" }}
          value={qualification}
          onSelect={(value) => updatePreference(workerPreferences.QUALIFICATION, value)}
          disabled={agentQualifications.length < 2}
        >
          {agentQualifications.map((value) => (
            <Option key={value} value={value}>
              {value}
            </Option>
          ))}
        </Select>
        {
          // eslint-disable-next-line no-nested-ternary
          isLoadingOpenShifts
            ? "Loading Shifts..."
            : // eslint-disable-next-line no-nested-ternary
              upcomingShifts
              ? `${upcomingShifts} Upcoming shifts found`
              : "No Upcoming shifts found"
        }
      </p>
    </Card>
  );
}

export { ShiftSearchPreference };
